import { Plus } from "lucide-react";
import SectionHeader from "../Common/SectionHeader";

const ContentHeader = ({ title, subtitle, actionLabel, onAction, actionVariant, actionClassName, showIcon = false }) => {
    return (
        <SectionHeader
            title={title}
            subtitle={subtitle}
            actionLabel={actionLabel}
            actionIcon={showIcon ? <Plus className="h-4 w-4" /> : null}
            onAction={onAction}
            actionVariant={actionVariant}
            actionClassName={actionClassName || "w-full md:w-auto"}
        />
    );
};

export default ContentHeader;
